import React from 'react';
import { Grid, Typography, Paper, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import PointOfContactCard from '../common/pointOfContactCard';
import { useLoanStore } from '@roc/feature-loans-shared';
import { observer } from 'mobx-react';
import { createPhoneField, createSelectField, createTextField } from '@roc/ui';
import { FormStore } from '@roc/feature-app-core';
import { useDrawsStore } from '../hooks';
import { PointOfContactV2Store } from './stores/pointOfContactV2Store';

const useStyles = makeStyles(theme => ({
  dealName: {
    display: 'flex',
    justifyContent: 'center',
  },
  paper: {
    padding: 24,
  },
  title: {
    paddingBottom: 24,
  },
}));

export const PointOfContactV2 = observer(
  ({
    pointOfContactV2Store,
    isInternalValuationPropertyPhotosContactFlow = false,
  }: {
    pointOfContactV2Store: PointOfContactV2Store;
    isInternalValuationPropertyPhotosContactFlow?: boolean;
  }) => {
    const { loanStore } = useLoanStore();
    const { drawStore } = useDrawsStore();
    const classes = useStyles();
    const formStore = pointOfContactV2Store.pointOfContactFormStore;
    const address = drawStore.drawDTO?.propertyAddress ?? '';
    const loanId = isInternalValuationPropertyPhotosContactFlow ? loanStore.loanDetails?.loanId : (drawStore.drawDTO?.draw?.loanId ?? '');
    const pointOfContacts = pointOfContactV2Store.pointOfContacts;

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box textAlign="center">
            <Typography variant="h6" style={{ fontWeight: 'bold' }}>
              {address}
            </Typography>
          </Box>
          <Box textAlign="center">
            <Typography variant="h6">Loan #{loanId}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h4">Point of Contact</Typography>
        </Grid>
        <Grid item xs={12}>
          {!isInternalValuationPropertyPhotosContactFlow && <Typography>
            You have the ability to send this task to a property manager or
            another partner on the project. Please add their information here.
          </Typography>}
          {isInternalValuationPropertyPhotosContactFlow && <Typography>
            You have the ability to send this task to a borrower or
            another partner on the project. Please add their information here.
          </Typography>}
        </Grid>
        <Grid item xs={12}>
          {createSelectField({
            testId: 'pointOfContactId',
            label: 'Select one option',
            fieldName: 'pointOfContactId',
            store: formStore,
            onChange: value =>
              pointOfContactV2Store.selectPointOfContact(value),
            options: pointOfContacts
              .map(poc => ({
                label: `${poc.firstName} ${poc.lastName}`,
                value: poc.pointOfContactId,
              }))
              .concat({
                label: 'Add new contact',
                value: null,
              }),
          })}
        </Grid>
        <Grid item xs={12}>
          {createTextField({
            testId: 'firstName',
            label: 'First Name',
            fieldName: 'firstName',
            store: formStore,
          })}
        </Grid>
        <Grid item xs={12}>
          {createTextField({
            testId: 'lastName',
            label: 'Last Name',
            fieldName: 'lastName',
            store: formStore,
          })}
        </Grid>
        <Grid item xs={12}>
          {createTextField({
            testId: 'email',
            label: 'Email',
            fieldName: 'email',
            store: formStore,
          })}
        </Grid>
        <Grid item xs={12}>
          {createPhoneField({
            testId: 'cellPhone',
            label: 'Phone Number',
            fieldName: 'phone',
            format: '###-###-####',
            store: formStore,
          })}
        </Grid>
      </Grid>
    );
  }
);
